import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 6 2 C 3.7840003 2 2 3.7840252 2 6 L 2 18 C 2 20.216013 3.7840003 22 6 22 L 18 22 C 20.216 22 22 20.216013 22 18 L 22 6 C 22 3.7840252 20.216 2 18 2 L 6 2 z M 17.414062 7.2128906 A 1.0001001 1.0001001 0 0 1 18.136719 8.9335938 L 10.578125 16.492188 A 1.0001001 1.0001001 0 0 1 9.1679688 16.492188 L 5.8613281 13.185547 A 1.0001001 1.0001001 0 1 1 7.2714844 11.767578 L 9.8769531 14.375 L 16.726562 7.515625 A 1.0001001 1.0001001 0 0 1 17.414062 7.2128906 z" />,
  'CheckboxMarked'
);
